import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from "react-toastify";
import { Col, ControlLabel, FormControl, FormGroup, Row, Checkbox } from 'react-bootstrap';
import { Form, Errors, actions, Control } from 'react-redux-form';
import Select from '../../../../common/form/dropdown';
import Number from '../../../../common/form/spinner';
import RequiredInput from '../../../../common/form/elements/required-input';
import RequiredSelect from '../../../../common/form/elements/required-select';
import { getBrands } from "../../../../../actions/brands";
import ImageUpload from "../../../../common/form/elements/image-upload";
import { getProduct, getGroups, saveProduct, updateProduct, getReplacementProducts } from "../../../../../actions/products";
import PageTitle from "../../../../common/page-title/index";
import BackLink from '../../../../common/back-link/index';
import ArrowButton from '../../../../common/button-arrow';
import RequiredMultiSelect from '../../../../common/form/elements/required-multi-select';
import ColorPicker from '../../../../common/form/elements/color-picker';
import ToastMessage from "../../../../common/toast-message";
import { validators } from "../../../../../utils/validators";

const statusOptions = [
  { value: 'ACTIVE', label: 'ACTIVE' },
  { value: 'INACTIVE', label: 'INACTIVE' }
];

const stockStatusOptions = [
  { value: 'In Stock', label: 'In Stock' },
  { value: 'Out of Stock', label: 'Out of Stock' },
  { value: 'Discontinued', label: 'Discontinued' }
];

class NewProduct extends Component {
  constructor(props) {
    super(props);

    this.id = this.props.match.params.id;
  }

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getBrands());
    dispatch(getGroups());
    dispatch(getReplacementProducts());

    if (this.isEdit()) {
      dispatch(getProduct(this.id));
    } else {
      dispatch(actions.reset('deep.admin_product_save'));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.admin_product_save'));
  }

  isEdit() {
    return this.id && parseInt(this.id);
  }

  isProductLoading() {
    const { productLoading } = this.props;

    return this.isEdit() && productLoading;
  }

  showReplacementProduct() {
    const { formData } = this.props;
    const stockStatus = formData.stock_status;

    return stockStatus === 'Out of Stock' || stockStatus === 'Discontinued';
  }

  disableAutoReplace() {
    const {
      dispatch,
      formData: { stock_status, replacement_product_id }
    } = this.props;

    return new Promise((resolve, reject) => {
      if (stock_status === 'In Stock' || (replacement_product_id || '').length === 0) {
        dispatch(actions.change('deep.admin_product_save.auto_replace', false));
      }

      resolve();
    });
  }

  handleSubmit = () => {
    const { dispatch, formData } = this.props;

    this.disableAutoReplace().then(() => {
      if (formData.max_per_order > 0 && formData.minimum_order_quantity > formData.max_per_order) {
        return toast.error(<ToastMessage iconStyle="error" message="Minimum order quantity must be less than order limit"/>);
      }

      if (this.isEdit()) {
        dispatch(actions.submitFields('deep.admin_product_save', updateProduct(this.id, formData, dispatch)));
      } else {
        dispatch(actions.submitFields('deep.admin_product_save', saveProduct(formData, dispatch)));
      }
    });
  };

  createGroupList = (groups) => {
    return groups.map((curr) => {
      return {
        label: `${curr.name}`,
        value: curr.id
      };
    });
  };

  createReplacementProductsList(products) {
    return products.reduce((collection, { id, name, sku }) => {
      if (id.toString() !== this.id) {
        collection.push({ value: id, label: `${sku} - ${name}` });
      }

      return collection;
    }, []);
  }

  handleChange(event, that) {
    const { dispatch } = this.props;
    let model='deep.admin_product_save.group_ids';

    dispatch(actions.setErrors(model, {
      required: event.target.checked
    }));

    if (event.target.checked) {
      dispatch(actions.change(model, []));
    }
  }

  render() {
    const brands = [];
    const categories = [];
    const groups = this.createGroupList(this.props.groups);
    const replacementProducts = this.createReplacementProductsList(this.props.replacementProducts);

    this.props.brands.forEach(category => {
      categories.push(category);

      if (this.props.category_id != parseInt(category.id)) {
        return;
      }

      category.attributes.brands.forEach((brand) => {
        if(!brands.find(existingBrand => existingBrand.id === brand.id)) {
          brands.push(brand);
        }
      });
    });

    let requiredMultiSelectValue = this.props.product.all_groups == true ? [{ label: 'All', value: 'all' }] : this.props.savedGroups;

    if (this.isProductLoading()) {
      return (
        <div className="container-fluid">
          <PageTitle>{this.isEdit() ? 'Edit Product' : 'Add Product'}</PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      )
    }

    let image = '';
    let marketingImage = '';
    const colors = ['Red', 'Yellow', 'White', 'Grey'];

    if (this.props.formData.hasOwnProperty('links')) {
      let links = this.props.formData.links;

      if (links.hasOwnProperty('photo')) {
        image = links.photo;
      }

      if (links.hasOwnProperty('marketing-image')) {
        marketingImage = links['marketing-image'];
      }
    }

    return (
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/products"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>{this.isEdit() ? 'Edit Product' : 'Add Product'}</PageTitle>
          </Col>
        </Row>
        <Form model='deep.admin_product_save' onSubmit={this.handleSubmit}>
          <Row>
            <Col md={12}>
              <Errors className="errors" model="deep.admin_product_save"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput label="Name"
                             placeholder="Name"
                             model='.name'
                             controlId='name'/>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <RequiredSelect model=".status"
                              values={statusOptions}
                              label="Status"
                              controlId="productStatus"/>

            </Col>
            <Col md={6}>
              <RequiredSelect model=".stock_status"
                              values={stockStatusOptions}
                              label="Stock Status"
                              controlId="stockStatus"/>
            </Col>
          </Row>
          {this.showReplacementProduct() && (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>Replacement Product</ControlLabel>
                  <Select
                    searchable={true}
                    model="deep.admin_product_save.replacement_product_id"
                    data={replacementProducts}
                    value={this.props.formData.replacement_product_id}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
          <Row>
            <Col sm={3}>
              <Control.checkbox model="deep.admin_product_save.special_new" component={Checkbox} >New</Control.checkbox>

              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.admin_product_save.special_new"/>
            </Col>
            <Col sm={3}>
              <Control.checkbox model="deep.admin_product_save.special_featured" component={Checkbox} >Featured</Control.checkbox>

              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.admin_product_save.special_featured"/>
            </Col>
            <Col sm={3}>
              <Control.checkbox model="deep.admin_product_save.special_reward" onClick={this.handleChange.bind(this)}  component={Checkbox} >Reward</Control.checkbox>

              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.admin_product_save.special_reward"/>
            </Col>
            <Col sm={3}>
              <Control.checkbox model="deep.admin_product_save.vape" component={Checkbox} >Vape</Control.checkbox>

              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.admin_product_save.vape"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Control.checkbox model="deep.admin_product_save.exclude_from_marketing" component={Checkbox} >Exclude from marketing</Control.checkbox>

              <Errors
                show={{touched: true}}
                className="errors"
                model="deep.admin_product_save.exclude_from_marketing"/>
            </Col>
          </Row>
          <Row>
            {
              (this.props.currentStockStatus === 'Discontinued' || this.props.currentStockStatus === 'Out of Stock') &&
              <Col md={12}>
                <Control.checkbox model="deep.admin_product_save.auto_replace" component={Checkbox}>Auto Replace</Control.checkbox>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.auto_replace"/>
              </Col>
            }
          </Row>
          {this.props.formData.special_reward === true &&
            <div>
              <Row>
                <Col md={12}>
                  <RequiredMultiSelect
                    model='deep.admin_product_save.group_ids'
                    data={this.createGroupList(this.props.groups) || []}
                    label="Eligible Groups"
                    value={requiredMultiSelectValue}
                    controlId="groups"
                    withAllOption={true} />
                </Col>
              </Row>
            </div>
          }
          <Row>
            <Col md={12}>
              <ControlLabel>Image*</ControlLabel>
              <ImageUpload onImageLoaded={this.onImageLoaded}
                           source={image}
                           model="deep.admin_product_save.photo"
                           sizeLimit={7000000}
                           type={['image/png', 'image/jpg', 'image/jpeg', 'image/gif',]}
                           required/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ControlLabel>Marketing image</ControlLabel>
              <ImageUpload onImageLoaded={this.onImageLoaded}
                           source={marketingImage}
                           model="deep.admin_product_save.marketing_image"
                           sizeLimit={1024 * 1024}
                           type={['image/png', 'image/jpg', 'image/jpeg']}/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup
                controlId="marketing_text_color"
                onChange={() => this.props.dispatch(actions.resetValidity('deep.admin_product_save.marketing_text_color'))}
              >
								<ColorPicker
									model="deep.admin_product_save.marketing_text_color"
									name="deep.admin_product_save.marketing_text_color"
									textModel="deep.admin_product_save.marketing_text_color"
									textName="deep.admin_product_save.marketing_text_color"
									label="Marketing text colour"
									defaultColor={this.props.marketingTextColor || colors[0]}
									defaultTextColor={this.props.marketingTextColor || colors[0]}
									backgroundColorPicker={false}
									key={"deep.admin_product_save.marketing_text_color"}
									colors={colors}
								/>
							</FormGroup>
              <Errors
                show={{touched: true, focus: false}}
                className="errors"
                model="deep.admin_product_save.marketing_text_color"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="marketing_title">
                <ControlLabel>Marketing Title</ControlLabel>
                <Control.text
                  model="deep.admin_product_save.marketing_title"
                  component={FormControl}
                />
                <Errors
                  show={{touched: true, focus: false}}
                  className="errors"
                  model="deep.admin_product_save.marketing_title"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="marketing_text">
                <ControlLabel>Marketing Text</ControlLabel>
                <Control.text
                  model=".marketing_text"
                  component={FormControl}
                />
                <Errors
                  show={{touched: true, focus: false}}
                  className="errors"
                  model=".marketing_text"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <RequiredInput
                  label="Sku"
                  placeholder="Sku"
                  model='.sku'
                  controlId='sku'
                  validations={{
                    noSpaces: validators.matches(/^\S*$/),
                    isInteger: validators.valueIsInteger()
                  }}
                  messages={{
                    noSpaces: 'Must not contain space.',
                    isInteger: 'Only numbers are allowed.'
                  }}
                />
                <Errors
                  show={{touched: true, focus: false}}
                  className="errors"
                  model=".sku"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput label="EAN"
                             placeholder="EAN"
                             model=".ean"
                             controlId="ean"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredSelect model=".category_id"
                              values={categories}
                              label="Category"
                              labelAttr="attributes.name"
                              valueAttr="id"
                              controlId="category"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredSelect model=".brand_id"
                              values={brands}
                              label="Brand"
                              labelAttr="name"
                              valueAttr="id"
                              controlId="brand"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput label="RSP (&euro;)"
                             placeholder="e.g 9.99"
                             model=".rsp"
                             controlId="rsp"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput label="Outer Price (&euro;)"
                             placeholder="e.g 9.99"
                             model=".outer_price"
                             controlId="outer_price"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="units_per_outer">
                <ControlLabel>Units per outer*</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.units_per_outer"/>
                <br />
                <Number model="deep.admin_product_save.units_per_outer"
                        min={1}
                        value={parseInt(this.props.formData.units_per_outer) || 0}
                        required/>

              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="order_limit_outers">
                <ControlLabel>Order limit (outers)*</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.max_per_order"/>
                <br/>
                <Number model="deep.admin_product_save.max_per_order"
                        min={0}
                        value={parseInt(this.props.formData.max_per_order) || 0}
                        required/>

              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="minimum_order_quantity">
                <ControlLabel>Minimum order quantity</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.minimum_order_quantity"/>
                <br/>
                <Number model="deep.admin_product_save.minimum_order_quantity"
                        min={0}
                        value={parseInt(this.props.formData.minimum_order_quantity) || 0}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="tar">
                <ControlLabel>Tar (mg)</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.tar"/>
                <Control.text model="deep.admin_product_save.tar"
                              component={FormControl}/>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="nicotine">
                <ControlLabel>Nicotine (mg)</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.nicotine"/>
                <Control.text model="deep.admin_product_save.nicotine"
                              component={FormControl}/>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="flavour">
                <ControlLabel>Flavour</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.flavour"/>
                <Control.text model="deep.admin_product_save.flavour"
                              component={FormControl}/>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="wording">
                <ControlLabel>Wording</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.admin_product_save.wording"/>
                <Control.text model="deep.admin_product_save.wording"
                              component={FormControl}
                              maxLength="70"/>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={2} mdOffset={10}>
              <ArrowButton className="pull-right"
                           arrow={false}
                           disabled={!this.props.formValid}>Save</ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    formData: state.deep.admin_product_save,
    formValid: state.deep.forms.admin_product_save.$form.valid,
    brands: state.brands.brands,
    product: state.products.product,
    category_id: state.deep.admin_product_save.category_id,
    productLoading: state.products.fetching && !state.products.fetched,
    savedGroups: state.deep.admin_product_save.group_ids || [],
    groups: state.groupSelector.groups || [],
    replacementProducts: state.products.replacementProducts || [],
    currentStockStatus: state.deep.admin_product_save.stock_status,
    marketingTextColor: state.deep.admin_product_save.marketing_text_color,
  };
};

export default connect(mapStateToProps)(NewProduct);



// WEBPACK FOOTER //
// ./src/components/admin/products/products/add/index.jsx